module.exports = __webpack_public_path__ + "img/IMG_1883.49b67e02.jpg";